import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import { notify } from '../../versa/msgbox.js';
import view from '../views/warehouses.js';
import form from '../forms/warehouses.js';
import * as types from '../types.js';

const warehouses = function()
{

	let warehouses_crud = crud.create({
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(error => notify(error)));
		},
		async queryData(query)
		{
			return await api.call(api.list_warehouses, query);
		},
		async loadRecord(id)
		{
			return await api.call(api.select_warehouse, ...JSON.parse(id));
		},
		async saveRecord(data, old_data)
		{
			let _record = {
				name: data.name,
			};
			if (old_data)
				return await api.call(api.update_warehouse, data.company_id, data.id, _record);
			else
				return await api.call(api.insert_warehouse, data.company_id, _record);
		},
	});
	
	// Index = position in the backend's SELECT
	let fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'id', label: 'Armazém', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador do armazém' },
		{ index: 3, field: 'name', label: 'Nome', types: [], placeholder: '', title: 'Nome do armazém' },
	];

	warehouses_crud.run(
		'warehouses',
		'Armazéns',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs
	);

};

export default warehouses;

